import classNames from 'classnames';

import {
  PageBgImageStyles,
  PageContainerStyles,
  PageStyles,
} from './Page.styles.ts';
import { OnboardingPageBgVariantType } from './types';

export const OnboardingPage: React.FC<{
  background?: OnboardingPageBgVariantType;
  className?: string;
  children?: NonNullable<React.ReactNode>;
  TEST_ID?: string;
  bgImage?: NonNullable<React.ReactNode>;
  bgImageMask?: boolean;
  bgImageMaskClassName?: string;
}> = ({
  background = 'light-color',
  className,
  children,
  TEST_ID,
  bgImage,
  bgImageMask = true,
  bgImageMaskClassName,
}) => {
  return (
    <PageStyles
      className={classNames(className)}
      background={background}
      data-testid={TEST_ID || 'onboarding-page'}
    >
      <PageContainerStyles>
        {children}
        {bgImage && (
          <PageBgImageStyles
            className={bgImageMaskClassName}
            bgImageMask={bgImageMask}
          >
            {bgImage}
          </PageBgImageStyles>
        )}
      </PageContainerStyles>
    </PageStyles>
  );
};
